import type { Tuto, TutosCollection } from "../Tuto/type";
import type { MediaResourceItem } from "../types";
import type { Workshop, WorkshopsCollection } from "../Workshop/types";

export type LegacyFormat = Record<
  string,
  | (Omit<Workshop, "id" | "type"> & { learning_set_id: string })
  | (Omit<WorkshopsCollection, "id" | "type"> & { learning_set_id: string })
  | (Omit<MediaResourceItem, "id" | "type"> & {
      learning_item_id: string;
    })
  | (Omit<Tuto, "id" | "type"> & { learning_set_id: string })
  | (Omit<TutosCollection, "id" | "type"> & { learning_set_id: string })
>;

export const reformatResources = (
  data: LegacyFormat,
): Record<
  string,
  WorkshopsCollection | Workshop | TutosCollection | Tuto | MediaResourceItem
> => {
  return Object.values(data).reduce<
    Record<
      string,
      | WorkshopsCollection
      | Workshop
      | TutosCollection
      | Tuto
      | MediaResourceItem
    >
  >((record, resource) => {
    if ("learning_set_id" in resource) {
      const { learning_set_id, ..._resource } = resource;
      return {
        ...record,
        [learning_set_id]: {
          ..._resource,
          type: "set",
          id: resource.learning_set_id,
        },
      };
    } else {
      const { learning_item_id, ..._resource } = resource;
      return {
        ...record,
        [learning_item_id]: {
          ..._resource,
          type: "item",
          id: learning_item_id,
        },
      };
    }
  }, {});
};
